// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Mandant } from "../../api";
import { useGetMandant as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useMandantQueryKey(mandantId: string): QueryKey {
  return ["api", "v1", "mandanten", mandantId];
}

export function useMandant(
  mandantId: string,
  options: Omit<UseQueryOptions<Mandant, ApiError>, "queryKey" | "queryFn"> = {}
): Mandant {
  const getter = useGetter();
  return useQuery(
    useMandantQueryKey(mandantId),
    () => getter(mandantId),
    options
  ).data!;
}
